// extracted by mini-css-extract-plugin
export default {"link":"uDW_Qe","root":"FubTgk","label":"l7_2fn"};